import React from 'react';
import { Badge } from './Badge';
import { STATUS_META, StatusWilayah, statusColor } from '../data/binda';
interface StatusBadgeProps {
  status: StatusWilayah | string;
  className?: string;
  showDot?: boolean;
}
export function StatusBadge({
  status,
  className = '',
  showDot = false
}: StatusBadgeProps) {
  const isKnownStatus = status in STATUS_META;
  const color = isKnownStatus ? statusColor(status as StatusWilayah) : 'var(--muted-foreground)';
  const dot = isKnownStatus ? STATUS_META[status as StatusWilayah].dot : '';
  return <Badge variant="outline" className={`text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 ${className}`} style={{
    color: color,
    borderColor: color,
    backgroundColor: `color-mix(in srgb, ${color} 10%, transparent)`
  }} data-id="element-508">
      {showDot && <span className="mr-1.5" data-id="element-509">{dot}</span>}
      {status}
    </Badge>;
}